// Lib
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { useStyles } from './BreadcrumbsStyles';

const Breadcrumbs = ({ items }) => {
  const { classes, cx } = useStyles();
  const { pathname } = useLocation();

  return (
    <MuiBreadcrumbs
      className={classes.crumbs}
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb">
      {items.map(({ to, title }) => (
        <NavLink
          key={title}
          end
          to={to}
          state={{
            navigateFrom: pathname,
          }}
          className={({ isActive }) =>
            isActive ? cx(classes.link, classes.activeLink) : classes.link
          }>
          {title}
        </NavLink>
      ))}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;
